import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m18.809 5.871-3.692 3.691h1.258c.355 0 .656.301.656.657 0 .383-.3.656-.656.656h-2.844a.63.63 0 0 1-.656-.656V7.375c0-.355.273-.656.656-.656.356 0 .656.3.656.656V8.66l3.692-3.719a.644.644 0 0 1 .902 0c.274.274.274.684 0 .93zM8.199 4.805c.52-.137 1.094.11 1.285.629l1.094 2.625c.192.437.082.957-.3 1.257l-1.34 1.121a9.2 9.2 0 0 0 4.374 4.376l1.122-1.34c.3-.383.82-.493 1.257-.301l2.625 1.094c.493.191.766.765.63 1.285l-.657 2.406a1.08 1.08 0 0 1-1.039.793A12.23 12.23 0 0 1 5 6.5c0-.492.328-.902.793-1.04z"
    }, null, -1)
  ]))]))
}
export default { render: render }